import React, {useEffect, useState} from "react";
import Link from "@mui/material/Link";
import {Alert} from "@mui/material";
import {StartAuthenticationFlowFunction} from "../auth/authentication";

interface LoginPageProps {
    startAuthenticationFlow: StartAuthenticationFlowFunction
}

function LoginPage({startAuthenticationFlow}: LoginPageProps): JSX.Element {
    const [error, setError] = useState<null | boolean>(false);
    useEffect(() => {
        startAuthenticationFlow().catch(() => {
            setError(true);
        });
    });

    return <div>
        {!error &&
            <Alert severity="info">No Session Found. Redirecting to Login Page...</Alert>
        }
        {error &&
            <Alert severity="error">Failed to start login process, <Link sx={{ cursor: 'pointer' }} onClick={window.location.reload}>refresh the page</Link></Alert>
        }
    </div>;
}

export default LoginPage;
